import React from 'react';

export const brandContext = React.createContext(undefined);
brandContext.displayName = 'BrandNameContext'
